'use strict';

angular.module('utils').factory('OCMapUtil', function() {
  return {
    newMap: function(canvas, latitude, longitude) {
      if (!canvas) {
        return;
      }
      return new google.maps.Map(canvas, {
        center: {
          lat: latitude,
          lng: longitude,
        },
        zoom: 15,
        scrollwheel: false,
        disableDoubleClickZoom: true,
        mapTypeControlOptions: {
          mapTypeIds: [],
        },
        disableDefaultUI: true,
        draggable: false,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
      });
    },
    addMarker: function(map, latitude, longitude) {
      return new google.maps.Marker({
        position: new google.maps.LatLng(latitude, longitude),
        map: map,
        optimized: false,
        icon: new google.maps.MarkerImage('/img/map/marker-teal.png', new google.maps.Size(24, 36), new google.maps.Point(0, 0), new google.maps.Point(12, 36), new google.maps.Size(24, 36)),
      });
    },
    setMapMarkerPosition: function(map, marker, latitude, longitude) {
      if (!map || !marker) {
        return;
      }
      var latlng = {
        lat: latitude,
        lng: longitude,
      };
      map.setCenter(latlng);
      marker.setPosition(latlng);
    },
  };
});
